<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Guardian Invite"
    seFeDataSubtitle="Invite Guardian for Child in Household"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-guardian-invite></se-po-guardian-invite>
  </se-fe-card-content>
</se-fe-card>
